import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DcBadgeModule } from '@datachain/ui-sdk/components/app-badge';
import { DcButtonModule } from '@datachain/ui-sdk/components/app-button';
import { DcOverlayBadgeModule } from '@datachain/ui-sdk/components/app-overlay-badge';
import { DcPageModule } from '@datachain/ui-sdk/components/app-page';
import { DcPanelModule } from '@datachain/ui-sdk/components/app-panel';
import { DcPopoverModule } from '@datachain/ui-sdk/components/app-popover';
import { DcAvatarModule } from '@datachain/ui-sdk/components/avatar';
import { DcBreadcrumbModule } from '@datachain/ui-sdk/components/breadcrumb';
import { DcArrayPipeModule } from '@datachain/ui-sdk/pipes';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DxDataGridModule } from 'devextreme-angular';

import { MaterialModule } from '../ui/material.module';
import { UiModule } from '../ui/ui.module';
import { MapActionPopupComponent } from './components/map-action-popup/map-action-popup.component';
import { MapListComponent } from './components/map-list/map-list.component';
import { MapAdapter } from './map.adapter';
import { MapEffects, MapFeatureKey, mapReducers, MapSelector } from './store';

@NgModule({
	declarations: [MapListComponent, MapActionPopupComponent],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		UiModule,
		MaterialModule,
		FormsModule,
		StoreModule.forFeature(MapFeatureKey, mapReducers),
		EffectsModule.forFeature([MapEffects]),
		DxDataGridModule,
		NgOptimizedImage,
		DcPageModule,
		DcPanelModule,
		DcArrayPipeModule,
		DcAvatarModule,
		DcBadgeModule,
		DcBreadcrumbModule,
		DcOverlayBadgeModule,
		DcPopoverModule,
		DcButtonModule,
	],
	providers: [MapAdapter, MapSelector],
})
export class MapModule {
	public constructor(private readonly injector: Injector) {
		const mapListCmpElement = createCustomElement(MapListComponent, {
			injector,
		});
		customElements.define('app-map-list', mapListCmpElement);
	}
}
